module.exports = __webpack_public_path__ + "media/images/symbols/eedn-logo-5a0624a8319e9893b61cda490489e2d3.png";